export default "__VITE_ASSET__ClIo3WNx__"